<template>
  <b-container fluid style="margin-top:-25px;">
    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-button variant="blue" @click="onAddSite" size="sm">
          <b-icon-plus /> Add new site
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <dx-data-grid
          :onEditingStart="onSiteSelection"
          :dataSource="dat"
          :columns="columns"
          :editing="editing"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    tempData: {
      default: []
    },
    acctId: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      columns: [
        {
          dataField: "name",
          caption: "Site",
          sortOrder: "asc"
        },
        {
          caption: "Open Orders",
          width: 100,
          alignment: "center",
          calculateDisplayValue(e) {
            return e.orders.length;
          }
        }
        // {
        //   caption: "Devices",
        //   width: 100,
        //   alignment: "center",
        //   calculateDisplayValue(e) {
        //     return e.devices.length;
        //   }
        // }
      ],
      selection: {
        mode: "single"
      },
      editing: {
        allowUpdating: true
      },
      dat: this.tempData.data.sites
    };
  },
  computed: {
    accounts() {
      return this.$store.getters["accounts/accounts"];
    },
    selectedAccount: {
      get() {
        return this.$store.getters["accounts/currentAccount"];
      },
      set(val) {
        this.$store.dispatch("accounts/currentAccount", val);
      }
    },
    selectedSite: {
      get() {
        return this.$store.getters["accounts/currentSite"];
      },
      set(val) {
        this.$store.dispatch("accounts/currentSite", val);
      }
    }
  },
  methods: {
    getDSSource() {
      debugger;
      var arr = [];
      this.tempData.forEach(s => arr.push(s));
      arr = this.tempData;
      return arr;
    },
    onAddSite(e) {
      debugger;

      var site = {
        id: 0,
        account_id: this.acctId,
        name: "New Site",
        address: "",
        city: "",
        state: "",
        postal_code: "",
        orders: [],
        devices: [],
        users: [],
        favorites: [],
        memberships: []
      };

      debugger;
      this.$emit("addSiteClick", site);
    },
    onSiteSelection(e) {
      debugger;
      e.cancel = true;

      var rtr = this.$router;

      var account = this.accounts.find(a => a.id === e.data.account_id);

      if (!account) {
        alert("No Account found!");
        return;
      }

      var name = account.name.trim().replace(" ", "_");
      var siteId = e.data.id;

      this.selectedAccount = account;
      this.selectedSite = e.data;

      return this.$store.dispatch("accounts/getCaUsers").then(rsp => {
        debugger;
        return this.$store
          .dispatch("sysItems/getItems")
          .then(() => rtr.push("/account/" + name + "/" + siteId));
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/SiteTemp.vue